module.exports = require("@swa-ui/personas");